import { SortingType } from "./index";

const descendingComparator = (a: any, b: any, sortBy: keyof any) => {
    if (b[sortBy] < a[sortBy]) {
        return -1;
    }
    if (b[sortBy] > a[sortBy]) {
        return 1;
    }
    return 0;
}

export const getComparator = (sortingType: SortingType, sortBy: string): (a: string, b: string) => number  => {
    return sortingType === 'desc'
      ? (a, b) => descendingComparator(a, b, sortBy)
      : (a, b) => -descendingComparator(a, b, sortBy);
  } 
  
export const stableSort = (array: any[], comparator: (a: any, b: any) => number) => {
    const stabilizedThis = array.map((element, index) => [element, index] as [any, number]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((element) => element[0]);
}
